import React from 'react';
import DividerBase from '@material-ui/core/Divider';

const Divider = (props) => <DividerBase {...props} />;

export default Divider;
